import { render, staticRenderFns } from "./InitialDocumentsAppRightToAppealPg.vue?vue&type=template&id=5f9201d4&scoped=true"
import script from "./InitialDocumentsAppRightToAppealPg.vue?vue&type=script&lang=ts"
export * from "./InitialDocumentsAppRightToAppealPg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9201d4",
  null
  
)

export default component.exports